/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateActivityCommentRequest
 */
export interface CreateActivityCommentRequest {
  /**
   *
   * @type {string}
   * @memberof CreateActivityCommentRequest
   */
  activityCommentId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityCommentRequest
   */
  activityId: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CreateActivityCommentRequest
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CreateActivityCommentRequest
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityCommentRequest
   */
  text: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateActivityCommentRequest
   */
  isPinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateActivityCommentRequest
   */
  replyTo?: string;
}

/**
 * Check if a given object implements the CreateActivityCommentRequest interface.
 */
export function instanceOfCreateActivityCommentRequest(
  value: object,
): value is CreateActivityCommentRequest {
  if (!("activityId" in value) || value["activityId"] === undefined)
    return false;
  if (!("text" in value) || value["text"] === undefined) return false;
  return true;
}

export function CreateActivityCommentRequestFromJSON(
  json: any,
): CreateActivityCommentRequest {
  return CreateActivityCommentRequestFromJSONTyped(json, false);
}

export function CreateActivityCommentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateActivityCommentRequest {
  if (json == null) {
    return json;
  }
  return {
    activityCommentId:
      json["activityCommentId"] == null ? undefined : json["activityCommentId"],
    activityId: json["activityId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    text: json["text"],
    isPinned: json["isPinned"] == null ? undefined : json["isPinned"],
    replyTo: json["replyTo"] == null ? undefined : json["replyTo"],
  };
}

export function CreateActivityCommentRequestToJSON(
  json: any,
): CreateActivityCommentRequest {
  return CreateActivityCommentRequestToJSONTyped(json, false);
}

export function CreateActivityCommentRequestToJSONTyped(
  value?: CreateActivityCommentRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activityCommentId: value["activityCommentId"],
    activityId: value["activityId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    text: value["text"],
    isPinned: value["isPinned"],
    replyTo: value["replyTo"],
  };
}
